import type { ReactNode } from 'react';

export type Tone = 'ok' | 'warn' | 'danger' | 'info' | 'accent' | 'neutral' | 'busy';

const TONE_STYLES: Record<Tone, { bg: string; text: string }> = {
  ok: { bg: 'var(--ok-soft)', text: 'var(--ok)' },
  warn: { bg: 'var(--warn-soft)', text: 'var(--warn)' },
  danger: { bg: 'var(--danger-soft)', text: 'var(--danger)' },
  info: { bg: 'var(--info-soft)', text: 'var(--accent-ink)' },
  accent: { bg: 'var(--accent-soft)', text: 'var(--accent-ink)' },
  neutral: { bg: 'var(--surface-3)', text: 'var(--text-2)' },
  busy: { bg: 'var(--accent-soft)', text: 'var(--busy)' },
};

export interface StatusBadgeProps {
  tone?: Tone;
  children: ReactNode;
  dot?: boolean;
  size?: 'sm' | 'md';
}

export function StatusBadge({ tone = 'neutral', children, dot, size = 'md' }: StatusBadgeProps) {
  const s = TONE_STYLES[tone];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: size === 'sm' ? '1px 8px' : '3px 10px',
        borderRadius: 'var(--r-pill)',
        background: s.bg,
        color: s.text,
        fontSize: size === 'sm' ? 'var(--t-xs)' : 'var(--t-sm)',
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: s.text,
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  );
}
